module.exports = __webpack_public_path__ + "img/transverse_active.ccddb7b2.svg";